/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox } from "@/components/ui/checkbox";
import { useTypedTranslations } from "@/i18n/typed";
import Image from "next/image";

type CategoryItem = {
  id: string;
  name: string;
  icon: string;
  isChecked?: boolean;
};

type CategoryGroupProps = {
  parent?: string;
  categories: CategoryItem[];
  selectedCategoryIds: string[];
  onSelectCategory: (id: string) => void;
};

export const ListMediaCategory: React.FC<CategoryGroupProps> = ({
  parent = "",
  categories,
  selectedCategoryIds,
  onSelectCategory,
}) => {
  const t = useTypedTranslations("mediaCategory");
  return (
    <div
      className={`w-[166px] cursor-pointer ${
        parent === "" ? "bg-gray-50" : "border-r border-gray-400"
      }`}
    >
      <span
        className={`text-[8px] h-[14px] mt-1 block pb-1 w-full
            ${
              parent === ""
                ? ""
                : "font-pretendard font-light  leading-[100%] tracking-[0] text-black text-center border-b border-gray-400"
            }
            `}
      >
        {parent}
      </span>
      <ul>
        {categories.map((c: CategoryItem) => (
          <li
            key={c.id}
            onClick={() => onSelectCategory(c.id)}
            className="flex items-center justify-between px-[6px] py-[4px] rounded hover:bg-gray-100"
          >
            <div className="flex items-center gap-[4px]">
              <Image
                src={c.icon}
                alt={c.name}
                width={24}
                height={24}
                style={{ objectFit: "none", color: "red" }}
              />
              <span
                className={`font-pretendard font-normal text-[12px] leading-[120%] tracking-[-0.4px] text-gray-700 ${
                  selectedCategoryIds.includes(c.id) ? "text-gray-900" : ""
                }`}
              >
                {t(c.id as any)}
              </span>
            </div>
            <Checkbox
              className="size-[18px] rounded-[4px] border-[1.5px] cursor-pointer"
              checked={selectedCategoryIds.includes(c.id)}
              onCheckedChange={() => onSelectCategory(c.id)}
              onClick={(e) => e.stopPropagation()}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
